// extracted by mini-css-extract-plugin
export default {"header":"Abc_header__gMjzD","content":"Abc_content__BdjZR","row":"Abc_row__lU2qe","link":"Abc_link__jwbRa","title":"Abc_title__izJcy"};